module.exports = __webpack_public_path__ + "static/PP4s-f52bb18696bcb0a51a5c96b09ceef015.jpg";